module.exports = __webpack_public_path__ + "static/media/spinner.64fa2c15.gif";